import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/functions'

// import { firebaseConfig } from './config/firebase-config'
import firebaseConfig from './config/firebase-config'

const firebaseApp = firebase.initializeApp(firebaseConfig)
// export const db = this.$firebase.database()
// export const storage = this.$firebase.storage()
// export const functions = firebase.functions()
export default firebaseApp



// WEBPACK FOOTER //
// ./src/firebase-setup/index.js